import {
  List as MuiList,
  ListItem as MuiListItem,
  ListItemButton as MuiListItemButton,
  ListItemIcon as MuiListItemIcon,
  ListItemText as MuiListItemText,
} from '@mui/material';
import type { ListProps as MuiListProps } from '@mui/material/List';
import type { ListItemProps as MuiListItemProps } from '@mui/material/ListItem';
import type { ListItemButtonProps as MuiListItemButtonProps } from '@mui/material/ListItemButton';
import type { ListItemIconProps as MuiListItemIconProps } from '@mui/material/ListItemIcon';
import type { ListItemTextProps as MuiListItemTextProps } from '@mui/material/ListItemText';

export type ListProps = MuiListProps;
export type ListItemProps = MuiListItemProps;
export type ListItemButtonProps = MuiListItemButtonProps;
export type ListItemIconProps = MuiListItemIconProps;
export type ListItemTextProps = MuiListItemTextProps;

export const List = ({ ...rest }: ListProps): JSX.Element => <MuiList {...rest} />;
export const ListItem = ({ ...rest }: ListItemProps): JSX.Element => <MuiListItem {...rest} />;
export const ListItemButton = ({ ...rest }: ListItemButtonProps): JSX.Element => (
  <MuiListItemButton {...rest} />
);
export const ListItemIcon = ({ ...rest }: ListItemIconProps): JSX.Element => (
  <MuiListItemIcon {...rest} />
);
export const ListItemText = ({ ...rest }: ListItemTextProps): JSX.Element => (
  <MuiListItemText {...rest} />
);
